import rootReducer from './rootReducer';

import { defaultSettingsState } from './settings/reducer';
import { defaultAuthState } from './auth/reducer';
import { defaultGlobalNotificationsState } from './global-notifications/reducer';
import { defaultProjectState } from './project/reducer';
import { defaultBookingsState } from './bookings/reducer';
import { defaultUserState } from './user/reducer';
import { defaultUsersState } from './users/reducer';
import { defaultEntityState } from './entity/types';
import { defaultNotificationsState } from './notifications/reducer';
import { defaultSubcontractorState } from './subcontractors/reducer';
import { defaultZonesState } from './zones/reducer';
import { defaultBarriersState } from './barriers/reducer';

export type RootState = Omit<ReturnType<typeof rootReducer>, symbol>;

const defaultState: RootState = {
  settings: defaultSettingsState,
  auth: defaultAuthState,
  globalNotifications: defaultGlobalNotificationsState,
  notifications: defaultNotificationsState,
  projects: defaultProjectState,
  bookings: defaultBookingsState,
  user: defaultUserState,
  users: defaultUsersState,
  subcontractor: defaultSubcontractorState,
  zones: defaultZonesState,
  bookingProjectSettings: defaultEntityState,
  deliveryZone: defaultEntityState,
  equipment: defaultEntityState,
  blockedSlots: defaultEntityState,
  barriers: defaultBarriersState
};

export default defaultState;
